export const baseLocale = {
  // Core
  "industry": "FMCG",
  // Home / Hero
  'home.hero.headerText': 'NZ 🇳🇿',
  'home.hero.country': 'NZ',
  'home.hero.countryShort': 'NZ',

  // Footer
  'footer.email': 'hello@sizzle.nz',
  'footer.linkedinUrl': 'https://linkedin.com/company/sizzlenz',
  'footer.skimlinksFileId': '',

  // About
  'about.pageTitle': 'About Sizzle | Discovering the Best of NZ FMCG',
  'about.metaDescription':
    "Learn more about Sizzle, our mission to showcase Aotearoa's most exciting brands, and the team behind the platform.",
} as const satisfies Record<string, string>;
